import { useTonAddress, useTonWallet } from "@tonconnect/ui-react";
import {
  useWalletAssociation,
  WalletAssociationState,
} from "./useWalletAssociation";
import { ASSOCIATION_ROUTES } from "../constants/walletAssociation.constants";

interface UseTonWalletAssociationProps {
  requiresTon?: boolean;
}

/**
 * TON variant of the wallet association flow. Sources the TON address from the
 * active TonConnect session and delegates the check/auto-associate state
 * machine to the shared {@link useWalletAssociation} core.
 */
export const useTonWalletAssociation = ({
  requiresTon = false,
}: UseTonWalletAssociationProps = {}): WalletAssociationState => {
  const tonAddress = useTonAddress();
  const wallet = useTonWallet();

  return useWalletAssociation({
    requires: requiresTon,
    chain: "ton",
    walletAddress: tonAddress || null,
    connected: Boolean(wallet),
    addressField: "tonAddress",
    route: ASSOCIATION_ROUTES.ton,
  });
};
